var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListDotsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187456",
    "data-name": "Group 187456",
    transform: "translate(-297 -372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_154451",
    "data-name": "Rectangle 154451",
    transform: "translate(297 372)",
    fill: "#fff",
    stroke: "#61277f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-list-ul",
    "data-name": "Icon awesome-list-ul",
    d: "M1.955,3.375A1.955,1.955,0,1,0,3.909,5.33,1.955,1.955,0,0,0,1.955,3.375Zm0,6.516a1.955,1.955,0,1,0,1.955,1.955A1.955,1.955,0,0,0,1.955,9.891Zm0,6.516a1.955,1.955,0,1,0,1.955,1.955,1.955,1.955,0,0,0-1.955-1.955Zm18.244.652H7.167a.652.652,0,0,0-.652.652v1.3a.652.652,0,0,0,.652.652H20.2a.652.652,0,0,0,.652-.652v-1.3A.652.652,0,0,0,20.2,17.058Zm0-13.031H7.167a.652.652,0,0,0-.652.652v1.3a.652.652,0,0,0,.652.652H20.2a.652.652,0,0,0,.652-.652v-1.3A.652.652,0,0,0,20.2,4.027Zm0,6.516H7.167a.652.652,0,0,0-.652.652v1.3a.652.652,0,0,0,.652.652H20.2a.652.652,0,0,0,.652-.652v-1.3A.652.652,0,0,0,20.2,10.542Z",
    transform: "translate(310 383.625)",
    fill: "#8e8e8e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDotsActive);
export default __webpack_public_path__ + "static/media/list-dots-active.53fa7cef942870bbab9eb51ad3886168.svg";
export { ForwardRef as ReactComponent };